// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.secretary-section[data-v-6cfc0597] {\n  margin-top: 20px;\n}\n.secretary-section__title[data-v-6cfc0597] {\n  color: #000;\n  font-size: 18px;\n}\n.secretary-section__field[data-v-6cfc0597] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.secretary-section__code-field[data-v-6cfc0597] {\n  width: 90px;\n  min-width: 90px;\n  margin-right: 15px;\n}\n.secretary-section__input[data-v-6cfc0597] {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
